import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { Flex } from 'reflexbox/styled-components'
import { Link } from 'react-router-dom'

import DataListingTable from 'components/DataListingTable'

import { DEFAULT_PAGE_SIZE } from 'constants/pagination'
import localStorage from 'helpers/localStorage'
import packageOrdersService from 'services/packageOrders'

const tableColumns = [
  {
    Header: 'Pedido',
    accessor: 'id',
  },
  {
    Header: 'Valor',
    accessor: 'amount',
  },
  {
    Header: 'Pacotes',
    accessor: 'packages',
    id: 'package_count',
  },
  {
    Header: 'Data da compra',
    accessor: 'purchase_date',
    id: 'created_at',
  },
  {
    Header: 'Status de Pagamento',
    accessor: 'payment_status',
    disableSortBy: true,
  },
  {
    Header: 'Recibo',
    accessor: 'receipt',
    disableSortBy: true,
  },
]

const PartnerOrderHistoryTable = () => {
  const [packageOrders, setPackageOrders] = useState([])
  const [sortBy, setSortBy] = useState(null)
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: localStorage.get('pageSize', DEFAULT_PAGE_SIZE),
    totalPages: 1,
    totalRecords: 0,
  })
  const [isLoading, setLoading] = useState(true)

  const handleTableDataFetch = ({ sortBy, currentPage, pageSize }) => {
    setSortBy(sortBy)
    setPagination({ ...pagination, currentPage, pageSize })
  }

  const fetchPackageOrders = async () => {
    setLoading(true)

    try {
      const response = await packageOrdersService.fetchAll({
        sortBy,
        pagination,
      })

      const packageOrders = response.packageOrders.map(({ id, receipt_url, ...packageOrder }) => ({
        ...packageOrder,
        id: <Link to={`/prepaid-purchase/my-packages/order-history/${id}`}>{id}</Link>,
        receipt: receipt_url ? (
          <a target='_blank' href={receipt_url}>
            Visualizar
          </a>
        ) : (
          '-'
        ),
      }))

      setPackageOrders(packageOrders)
      setPagination(response.pagination)
    } catch (e) {
      console.log(e)
      toast.error('Ocorreu algum erro no carregamento dos dados')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (sortBy) {
      fetchPackageOrders()
    }
  }, [sortBy, pagination.currentPage, pagination.pageSize])

  useEffect(() => {
    localStorage.set('pageSize', pagination.pageSize)
  }, [pagination.pageSize])

  return (
    <Flex flexDirection='column' width='100%'>
      <DataListingTable
        data={packageOrders}
        columns={tableColumns}
        pagination={pagination}
        loading={isLoading}
        fetchData={handleTableDataFetch}
      />
    </Flex>
  )
}

export default PartnerOrderHistoryTable
